import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import {  listKPI } from '../../../modules/empModule/empResume';

import KPIForm from '../../../components/employeemng/resume/KPIForm';

const KPIFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
    attrVal4: '',
    attrVal5: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('KPI 종류를 입력하세요'),
    attrVal2: yup.string().required('KPI 명을 입력하세요'),
    attrVal3: yup.string().required('KPI 설명을 입력하세요'),
    attrVal4: yup.string().required('KPI POINT를 입력하세요'),
    attrVal5: yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'KPI',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
        attrVal4: values.attrVal4,
        attrVal5: values.attrVal5,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listKPI({
              id: employee.usrUuid,
              infoTyp: 'KPI',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <KPIForm formik={formik} />;
};

export default KPIFormContainer;
